import { ProjectFormData } from '../../interfaces/ui/addProjectModal';
import { IqeProject } from '../../interfaces/ui';
import { IqeProjectOperationRequest } from '../../interfaces/api/requests/saveProject.request';
import type { ProjectOperationStage } from '../../interfaces/ui';
import { toSystemValue } from '../../utils';

/**
 * Maps a stored IqeProject (from API list state) to a full IqeProjectOperationRequest
 * for action operations: RERUN, GENERATE, EXECUTE, ENHANCE.
 */
export function mapIqeProjectToActionRequest(
  project: IqeProject,
  operation: Exclude<ProjectOperationStage, 'CREATE'>,
): IqeProjectOperationRequest {
  return {
    projectId: project.id,
    projectName: project.name,
    appUrl: project.appUrl,
    loginNotRequired: project.loginNotRequired ?? false,
    environment: project.environment,
    system: toSystemValue(project.projectMappingType),
    mappedProject: project.mappedProject,
    organization: project.mappedProjectOrg || '',
    testPlanName: project.testPlanName,
    testPlanId: project.testPlanId,
    testSuiteName: project.testSuiteName,
    testSuiteId: project.testSuiteId,
    flowId: project.flowId,
    flowName: project.flowName,
    operation,
  };
}

export function mapFormToSaveProjectRequest(
  formData: ProjectFormData,
): IqeProjectOperationRequest {
  return {
    projectId: '',
    projectName: formData.projectName,
    appUrl: formData.appUrl,
    loginNotRequired: formData.loginNotRequired,
    environment: formData.environment,
    system: toSystemValue(formData.projectMappingType),
    mappedProject: formData.mappedProjectName,
    organization: formData.mappedProjectOrg,
    testPlanName: formData.testPlanName,
    testPlanId: formData.testPlanId,
    testSuiteName: formData.testSuiteName,
    testSuiteId: formData.testSuiteId,
    flowId: formData.flowId,
    flowName: formData.flowName,
    existingTestPlanId: formData.existingTestPlanId || undefined,
    existingTestPlanName: formData.existingTestPlanName || undefined,
    existingTestSuiteId: formData.existingTestSuiteId || undefined,
    existingTestSuiteName: formData.existingTestSuiteName || undefined,
    operation: 'CREATE',
  };
}
